function StationEnrollee() {
    "use strict";
    this.DeviceClusterId = -1;
    this.EnrolleeId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = StationEnrollee;
}